import EventBus from '..'

export interface ErrorState {
  /**
   * Error 객체
   */
  err: Error

  /**
   * 에러 Vue component
   */
  vm: Vue

  /**
   * 정보 문자열
   */
  info: string

  /**
   * event bus 수신 횟수
   */
  receivedCnt: number
}

export class ErrorEventBus extends EventBus<ErrorState> {
  name(): string {
    return 'errorEventBus'
  }
}

export default new ErrorEventBus()
